import { SuggestionSchema, type Suggestion } from '@pin/schemas/suggest';

export const getSuggest = async (
  query: string,
  participantId: string
): Promise<Suggestion | null> => {
  if (!query || query.length === 0) {
    return null;
  }

  try {
    const params = new URLSearchParams({ q: query, participantId });
    const response = await fetch(
      `${import.meta.env.VITE_SUGGEST_API_URL}/api/suggest?${params}`,
      {
        signal: AbortSignal.timeout(10_000),
      }
    );

    if (!response.ok) {
      return null;
    }

    if (response.status === 204) {
      return null;
    }

    const json = await response.json();
    return SuggestionSchema.parse(json);
  } catch (error) {
    console.error('Suggest API error:', error);
    return null;
  }
};
